import h from 'virtual-dom/h';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {VChild} from "virtual-dom";
import LiveChatState from "../livechat-state";


export default class TypingNotificationRenderer
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;


    //#region Public Interface

    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    getRenderer()
    {
        return (): VChild =>
        {
            const liveChatStatus = this._stateManager.sessionStatus;
            const isTyping = this.getOperatorTyping();

            if (liveChatStatus === this._settings.livechat.sessionState.offline || !isTyping)
            {
                return [];
            }

            const operatorData = this._stateManager.getLatestOperatorData();
            if (!operatorData)
            {
                return [];
            }

            const operatorName = operatorData.Name ?? this._settings.livechat.defaultOperatorName;
            const text = this._settings.livechat.textConstants.typingNotificationText.replace(/{0\}/g, operatorName);

            return h('div', { className: this._settings.classNames.livechat.typingNotification }, text);
        };
    }

    //#endregion



    //#region Helper Methods

    getOperatorTyping(): string
    {
        const { Base, operatorTyping } = this._settings.stateLocations.LiveChat;

        return this._store?.getState()[Base][operatorTyping];
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/typing-notification-renderer.ts